import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormControl } from "@angular/forms";

@Component({
    selector: "[pcg-ng-capacity-filter]",
    templateUrl: "./capacity-filter.component.html"
})
export class CapacityFilterComponent {

    @Input()
    public min: number = 1;

    @Input()
    public max: number = 1;

    public control: FormControl<Array<number>> = null;
    @Input("control")
    public set controlSetter(value: FormControl<Array<number>>) {
        this.control = value;
    }

    @Output()
    public onSubmit = new EventEmitter();

    public submit(): void {
        this.onSubmit.emit();
    }
}
